<template>
  <el-dialog title="任务列表" :visible.sync="visible" width="480px" custom-class="task-list-dialog">
    <div class="task-list">
      <div v-for="mod in modules" :key="mod.moduleId" class="task-item">
        <template
          v-if="
            mod.isShow &&
            (mod.moduleType === MODULE_TYPE.PRE_STUDY ||
              mod.moduleType === MODULE_TYPE.PERSONAL_TASK)
          "
        >
          <div class="task-title">
            <div class="task-dot"></div>
            {{ mod.moduleName }}
          </div>
          <div v-if="mod.tasks && mod.tasks.length" class="task-children">
            <div v-for="child in mod.tasks" :key="child.taskId" class="task-child">
              · {{ child.taskName }}
            </div>
          </div>
        </template>
        <template v-if="mod.isShow && mod.moduleType === MODULE_TYPE.TASK">
          <div v-for="subMod in mod.modules" :key="subMod.moduleId" class="period-mod">
            <div class="task-title">
              <div class="task-dot"></div>
              {{ subMod.moduleName }}
            </div>
            <div v-if="subMod.tasks.length" class="task-children">
              <div v-for="child in subMod.tasks" :key="child.moduleId" class="task-child">
                · {{ child.taskName }}
              </div>
            </div>
            <div
              v-if="subMod.homework && subMod.homework.tasks.length"
              class="task-children with-border"
            >
              <div v-for="child in subMod.homework.tasks" :key="child.moduleId" class="task-child">
                · {{ child.taskName }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'TaskListDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    periodsId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      MODULE_TYPE: {
        PRE_STUDY: 1,
        TASK: 2,
        HOMEWORK: 3,
        PERSONAL_TASK: 4,
      },
      modules: [],
    };
  },
  watch: {
    show: {
      immediate: true,
      async handler(val) {
        this.visible = val;
        if (val) {
          const data = await this.$http.get('/aiclass/lesson/tasks', {
            periodsId: this.periodsId,
          });
          // const data = {
          //   periodsId: -8923910.004994437,
          //   periodsName: 'dolor dolore ullamco exercitation ut',
          //   modules: [
          //     {
          //       moduleId: -53845290.31541345,
          //       moduleName: '预习模块',
          //       moduleType: 1,
          //       tasks: [
          //         {
          //           taskId: 'ullamco',
          //           taskName: '预习模块1',
          //         },
          //         {
          //           taskId: 'dolore nostrud tempor exercitation',
          //           taskName: '预习模块2',
          //         },
          //         {
          //           taskId: 'deserunt amet dolore dolor aliqua',
          //           taskName: '预习模块3',
          //         },
          //         {
          //           taskId: 'do exercitation',
          //           taskName: '预习模块4',
          //         },
          //       ],
          //     },
          //     {
          //       moduleId: -28136977.44757846,
          //       moduleName: '课时1',
          //       moduleType: 2,
          //       tasks: [
          //         {
          //           taskId: 'velit elit',
          //           taskName: '课时1~~~1',
          //         },
          //         {
          //           taskId: 'id cillum',
          //           taskName: '课时1~~~2',
          //         },
          //         {
          //           taskId: 'reprehenderit culpa id',
          //           taskName: '课时1~~~3',
          //         },
          //         {
          //           taskId: 'consequat id eiusmod esse et',
          //           taskName: '课时1~~~4',
          //         },
          //         {
          //           taskId: 'ullamco sint nostrud voluptate',
          //           taskName: '课时1~~~5',
          //         },
          //       ],
          //     },
          //     {
          //       moduleId: -62184937.81293377,
          //       moduleName: '作业',
          //       moduleType: 3,
          //       preModuleId: -28136977.44757846,
          //       tasks: [
          //         {
          //           taskId: 'dolo',
          //           taskName: '作业1',
          //         },
          //         {
          //           taskId: 'aliquip enim id adipisicing',
          //           taskName: '作业2',
          //         },
          //         {
          //           taskId: 'Lorem irure consectetur adipisicing',
          //           taskName: '作业3',
          //         },
          //         {
          //           taskId: 'dolor consectetur reprehenderit ad eu',
          //           taskName: '作业4',
          //         },
          //       ],
          //     },
          //     {
          //       moduleId: -28136977.44757846333,
          //       moduleName: 'keshi2',
          //       moduleType: 2,
          //       tasks: [
          //         {
          //           taskId: 'velit elit',
          //           taskName: 'keshi2~~~1',
          //         },
          //         {
          //           taskId: 'id cillum',
          //           taskName: 'keshi2~~~2',
          //         },
          //         {
          //           taskId: 'reprehenderit culpa id',
          //           taskName: 'keshi2~~~3',
          //         },
          //         {
          //           taskId: 'consequat id eiusmod esse et',
          //           taskName: 'keshi2~~~4',
          //         },
          //         {
          //           taskId: 'ullamco sint nostrud voluptate',
          //           taskName: 'keshi2~~~5',
          //         },
          //       ],
          //     },
          //   ],
          // };
          this.modules = this.handleModules(data && data.modules);
        }
      },
    },
    visible(val) {
      if (!val) {
        this.$emit('update:show', false);
      }
    },
  },
  methods: {
    handleModules(modules = []) {
      const resultMods = [
        {
          moduleId: 'prestudy-0',
          moduleName: '',
          moduleType: this.MODULE_TYPE.PRE_STUDY,
          isShow: false,
          tasks: [],
        },
        // 虚拟集合
        {
          moduleId: 'task-1',
          moduleType: this.MODULE_TYPE.TASK,
          isShow: false,
          // 多课时
          modules: [],
        },
        {
          moduleId: 'personal-task-2',
          moduleName: '',
          moduleType: this.MODULE_TYPE.PERSONAL_TASK,
          isShow: false,
          tasks: [],
        },
      ];

      // 临时存储作业模块
      const homeworkModules = [];
      modules.forEach((mod) => {
        if (mod.moduleType === this.MODULE_TYPE.HOMEWORK) {
          homeworkModules.push(mod);
          return;
        }
        if (mod.moduleType === this.MODULE_TYPE.PRE_STUDY) {
          const preTask = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.PRE_STUDY);
          Object.assign(preTask, {
            moduleId: mod.moduleId,
            moduleName: mod.moduleName,
            moduleType: mod.moduleType,
            isShow: true,
            tasks: mod.tasks,
          });
        } else if (mod.moduleType === this.MODULE_TYPE.PERSONAL_TASK) {
          const personalTask = resultMods.find(
            (t) => t.moduleType === this.MODULE_TYPE.PERSONAL_TASK,
          );
          Object.assign(personalTask, {
            moduleId: mod.moduleId,
            moduleName: mod.moduleName,
            moduleType: mod.moduleType,
            isShow: true,
            tasks: mod.tasks,
          });
        } else if (mod.moduleType === this.MODULE_TYPE.TASK) {
          // 主要课时！！
          const periodMod = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
          periodMod.isShow = true;
          periodMod.modules.push(mod);
        }
      });
      // 处理剩余的作业（关联的课时还未处理的情况）
      const periodMod = resultMods.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
      homeworkModules.forEach((homework) => {
        const targetTask = periodMod.modules.find((task) => task.moduleId === homework.preModuleId);
        if (targetTask && !targetTask.homeworks) {
          targetTask.homework = homework;
        }
      });
      return resultMods;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .task-list-dialog {
  padding: 24px;
  padding-left: 32px;

  .el-dialog__header {
    padding-top: 0;
    text-align: center;
    padding-bottom: 0;
    margin-bottom: 16px;
    font-weight: bolder;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 486px;
  }
}

.task-list {
  .task-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .task-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #1d1b20;
    line-height: 22px;
    padding-bottom: 8px;
    padding-top: 4px;

    .task-dot {
      width: 4px;
      height: 16px;
      background: #ff2020;
      border-radius: 2px;
      margin-right: 8px;
    }
  }

  .task-children {
    &.with-border {
      border-top: 1px solid #f1f3f9;
    }
    .task-child {
      font-size: 14px;
      color: #1e1c22;
      line-height: 28px;
      padding-left: 12px;
      margin-bottom: 4px;
    }
  }
}
.period-mod {
  margin-bottom: 16px;
}
</style>
